module.exports = __webpack_public_path__ + "img/1854ad51-54fc-444c-95b4-46e477e06a3a.3fdfc8c0dc484345ec889e2a20cc0cc4.a5c2846a.webp";